import { AfterViewInit, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'mcb-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.css'],
})
export class CaptchaComponent {
    @Input() image;
    @Output() reloadClick = new EventEmitter();

    constructor() {
    }
}

